var React = require('react');

function Raindrops (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M169.3 38.9c-2.5-9-15.7-9.4-18.6 0-14.9 49.3-46.7 62.7-46.7 97.4a56 56 0 0 0 112 0c0-34.9-31.8-47.9-46.7-97.4zm-122.6 192C31.8 280.2 0 293.6 0 328.3a56 56 0 0 0 112 0c0-34.9-31.8-47.9-46.7-97.4-2.5-9-15.7-9.4-18.6 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M341.2 143.2C375.4 252.1 448 280.7 448 357.6c0 67.6-57.2 122.4-128 122.4s-128-54.7-128-122.4c0-76.5 72.7-106 106.7-214.4 6.5-20.7 36.7-19.8 42.5 0z","className":"fa-primary","key":2})]);
}

Raindrops.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Raindrops;

Raindrops.default = Raindrops;
